import { List, Stack } from "@mui/material"

import HomeIcon from '@mui/icons-material/Home';
import GroupIcon from '@mui/icons-material/Group';
import CategoryIcon from '@mui/icons-material/Category';
import ReceiptIcon from '@mui/icons-material/Receipt';
import InventoryIcon from '@mui/icons-material/Inventory';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import SettingsIcon from '@mui/icons-material/Settings';
import SummarizeIcon from '@mui/icons-material/Summarize';
import DescriptionIcon from '@mui/icons-material/Description';
import PublicIcon from '@mui/icons-material/Public';

import DrawerItem from "./drawer-item";
import DrawerItemGroup from "./drawer-item-group";

import { Permiso } from "@/shared/types/permiso";
import { useAuthContext } from "@/features/auth/contexts/auth-context";
import { useOperationalMode } from "@/features/configuration/hooks/use-operational-mode";

//Editar esto para agregar mas tabs o navs
export default function DrawerContent() {
    //const permisoCheck = useItemPermisoCheck();
    const { hasPermisos } = useAuthContext();
    const { gestionEnabled, facturacionEnabled } = useOperationalMode();

    return <Stack component={"nav"}>
        <List component={Stack}>
            <DrawerItem to={"/"} title={"Home"} Icon={HomeIcon} />
            {gestionEnabled && (
                <DrawerItemGroup title="Caja" Icon={PointOfSaleIcon}>
                    {hasPermisos(Permiso.ReadMovimientoCajas) && <DrawerItem to={"/caja_actual"} title="Caja Actual" paddingLeft={4} />}
                    {hasPermisos(Permiso.ReadUnpaidVentas) && <DrawerItem to={"/pagar_venta"} title="Pagos Pendientes" paddingLeft={4} />}
                    {hasPermisos(Permiso.ReadCajas) && <DrawerItem to={"/cajas"} title="Lista de Cajas" paddingLeft={4} />}
                    {hasPermisos(Permiso.HistorialAperturaCajas) && <DrawerItem to={"/caja_historial"} title="Historial de Arqueo" paddingLeft={4} />}
                </DrawerItemGroup>
            )}
            {gestionEnabled && (
                <DrawerItemGroup title="Facturación" Icon={ReceiptIcon}>
                    {hasPermisos(Permiso.ReadVentas) && <DrawerItem to={"/ventas"} title={"Ventas"} paddingLeft={4} />}
                    {hasPermisos(Permiso.WriteVentas) && <DrawerItem to={"/nueva_venta"} title={"Nueva Venta"} paddingLeft={4} />}
                </DrawerItemGroup>
            )}
            {facturacionEnabled && (
                <DrawerItemGroup title="Facturación Electrónica" Icon={DescriptionIcon}>
                    {hasPermisos(Permiso.ReadDocumentosElectronicos) && <DrawerItem to={"/documentos-electronicos"} title={"Documentos Electrónicos"} paddingLeft={4} />}
                </DrawerItemGroup>
            )}
            {gestionEnabled && (
                <DrawerItemGroup title="Inventario" Icon={InventoryIcon}>
                    {hasPermisos(Permiso.ReadArticulos) && <DrawerItem to={"/articulos"} title={"Artículos"} paddingLeft={4} />}
                    {hasPermisos(Permiso.ReadDepositos) && <DrawerItem to={"/depositos"} title={"Depósitos"} paddingLeft={4} />}
                    {hasPermisos(Permiso.ReadCompras) && <DrawerItem to={"/compras"} title={"Compras"} paddingLeft={4} />}
                    {hasPermisos(Permiso.ReadArticuloTransferencias) && <DrawerItem to={"/articulo_transferencias"} title={"Transferencias"} paddingLeft={4} />}
                    {hasPermisos(Permiso.ReadArticuloMovimientos) && <DrawerItem to={"/articulo_movimientos"} title={"Movimientos"} paddingLeft={4} />}
                </DrawerItemGroup>
            )}
            <DrawerItemGroup title="Geografía" Icon={PublicIcon}>
                {hasPermisos(Permiso.ReadPaises) && <DrawerItem to="/paises" title="Países" paddingLeft={4} />}
                {hasPermisos(Permiso.ReadDepartamentos) && <DrawerItem to="/departamentos" title="Departamentos" paddingLeft={4} />}
                {hasPermisos(Permiso.ReadCiudadesAndBarrios) && <DrawerItem to="/ciudades" title="Ciudades" paddingLeft={4} />}
                {hasPermisos(Permiso.ReadCiudadesAndBarrios) && <DrawerItem to="/barrios" title="Barrios" paddingLeft={4} />}
            </DrawerItemGroup>
            {gestionEnabled && (
                <DrawerItemGroup title="Reportes" Icon={SummarizeIcon}>
                    {hasPermisos(Permiso.ReporteVentas) && <DrawerItem to={"/reporte_venta"} title="Resumen de Ventas" paddingLeft={4} />}
                    {hasPermisos(Permiso.ReporteVentaItems) && <DrawerItem to={"/reporte_venta_item"} title="Detalles de Venta" paddingLeft={4} />}
                </DrawerItemGroup>
            )}
            <DrawerItemGroup title="Auxiliares" Icon={CategoryIcon}>
                {hasPermisos(Permiso.ReadRubros) && gestionEnabled && <DrawerItem to={"/rubros"} title={"Rubro"} paddingLeft={4} />}
                {hasPermisos(Permiso.ReadActividadesComerciales) && facturacionEnabled && <DrawerItem to={"/actividades-comerciales"} title={"Actividades Comerciales"} paddingLeft={4} />}
                {hasPermisos(Permiso.ReadClientes) && <DrawerItem to={"/clientes"} title={"Clientes"} paddingLeft={4} />}
                {hasPermisos(Permiso.ReadProveedores) && gestionEnabled && <DrawerItem to={"/proveedores"} title={"Proveedores"} paddingLeft={4} />}
                {hasPermisos(Permiso.ReadVendedores) && gestionEnabled && <DrawerItem to={"/vendedores"} title={"Vendedores"} paddingLeft={4} />}
            </DrawerItemGroup>
            <DrawerItemGroup title="Administración" Icon={GroupIcon}>
                {hasPermisos(Permiso.ManageUsuarios) && <DrawerItem to={"/usuarios"} title={"Usuarios"} paddingLeft={4} />}
                {hasPermisos(Permiso.ManageOrganizaciones) && <DrawerItem to={"/organizaciones"} title={"Organizaciones"} paddingLeft={4} />}
                {hasPermisos(Permiso.Auditoria) && <DrawerItem to={"/auditoria"} title={"Auditoría"} paddingLeft={4} />}
            </DrawerItemGroup>

            <DrawerItemGroup title="Configuración" Icon={SettingsIcon}>
                {(hasPermisos(Permiso.ManageConfiguracion) || hasPermisos(Permiso.AsignarCajas) || hasPermisos(Permiso.AsignarDepositos)) && <DrawerItem to={"/configuracion"} title="Configuración General" paddingLeft={4} />}
                {hasPermisos(Permiso.ManageConfiguracionFacturacionElectronica) && facturacionEnabled && <DrawerItem to={"/configuracion/facturacion-electronica"} title={"Facturación Electrónica"} paddingLeft={4} />}
                {hasPermisos(Permiso.ManageConfiguracionFacturacionElectronica) && facturacionEnabled && <DrawerItem to={"/configuracion/emisor"} title={"Datos del Emisor"} paddingLeft={4} />}
            </DrawerItemGroup>
        </List>
    </Stack>
}

